/* unplugin-vue-components disabled */import script from "./publish-form.vue?vue&type=script&setup=true&lang=js"
export * from "./publish-form.vue?vue&type=script&setup=true&lang=js"

import "./publish-form.vue?vue&type=style&index=0&id=3c3c8094&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3c8094"]])

export default __exports__